(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thorndale-marketing-home"]) return;
  try {
    
(function () {
  function initEssentialsCarousel() {
    var scroller = document.querySelector('.th-essentials .th-scroller');
    if (!scroller || scroller.dataset.smoothSwipeReady === 'true') return;
    scroller.dataset.smoothSwipeReady = 'true';

    var originals = Array.prototype.slice.call(scroller.querySelectorAll('.th-product-placeholder'));
    if (!originals.length) return;

    var clones = originals.map(function (card) {
      var clone = card.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      var image = clone.querySelector('img');
      if (image) image.setAttribute('alt', '');
      scroller.appendChild(clone);
      return clone;
    });

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var interacting = false;
    var resumeTimer = null;
    var lastTime = null;
    var cachedLoopWidth = 0;

    function updateLoopWidth() {
      cachedLoopWidth = clones[0] ? clones[0].offsetLeft - originals[0].offsetLeft : 0;
      return cachedLoopWidth;
    }

    function loopWidth() {
      return cachedLoopWidth || updateLoopWidth();
    }

    function normalizePosition() {
      var width = loopWidth();
      if (!width) return;
      while (scroller.scrollLeft >= width) {
        scroller.scrollLeft -= width;
      }
    }

    function tick(time) {
      if (lastTime === null) lastTime = time;
      var delta = Math.min(time - lastTime, 50);
      lastTime = time;

      if (!reduceMotion && !interacting) {
        var width = loopWidth();
        if (width) {
          scroller.scrollLeft += (width / 24000) * delta;
          normalizePosition();
        }
      }
      window.requestAnimationFrame(tick);
    }

    function pauseForTouch() {
      interacting = true;
      if (resumeTimer) window.clearTimeout(resumeTimer);
    }

    function resumeAfterTouch() {
      if (resumeTimer) window.clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(function () {
        normalizePosition();
        interacting = false;
        lastTime = null;
      }, 1800);
    }

    function refreshLoopWidth() {
      cachedLoopWidth = 0;
      updateLoopWidth();
      normalizePosition();
      lastTime = null;
    }

    scroller.addEventListener('pointerdown', pauseForTouch, { passive: true });
    scroller.addEventListener('pointerup', resumeAfterTouch, { passive: true });
    scroller.addEventListener('pointercancel', resumeAfterTouch, { passive: true });
    scroller.addEventListener('touchstart', pauseForTouch, { passive: true });
    scroller.addEventListener('touchend', resumeAfterTouch, { passive: true });
    scroller.addEventListener('touchcancel', resumeAfterTouch, { passive: true });
    window.addEventListener('resize', refreshLoopWidth, { passive: true });

    updateLoopWidth();
    window.requestAnimationFrame(tick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEssentialsCarousel);
  } else {
    initEssentialsCarousel();
  }
  document.addEventListener('shopify:section:load', initEssentialsCarousel);
})();

  } catch(e) { console.error(e); }
})();
})();
